import src from "IMAGE";
export default { src, width: 1241, height: 201, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJUlEQVR42mNQVVWVc3BwMHF3d7cCYSMjIw0LCwt9Z2dncyDQBQByOQcHQFBTUAAAAABJRU5ErkJggg=="};
